<template>
  <div class="settings">
    <PageMenu :linksList="linksComputedList" />
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import PageMenu from '@/components/global/pageMenu';

export default {
  name: 'SettingsIndex',
  components: { PageMenu },
  computed: {
    ...mapGetters([
      'get_user_permission',
    ]),
    linksComputedList() {
      return [
        {
          name: 'Ftp',
          link: '/settings/integration/ftp',
          visible: this.get_user_permission('settings/ftp').view,
        },
        {
          name: 'Import templates',
          link: '/settings/integration/import-templates',
          visible: this.get_user_permission('settings/import-template').view,
        },
        {
          name: 'automations',
          link: '/settings/integration/automations',
          visible: this.get_user_permission('settings/automations').view,
        },
      ]
    },
  },
};
</script>
